import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ArrHlp } from 'src/lib/fliko/helpers/array.helper';
import {
  ESTATE_NOTIFY_DAYS,
  ESTATE_NOTIFY_KEYS,
  EstateNotify,
  EstateNotifyKey
} from 'src/lib/fliko/models/estate/estate-settings.data';
import { SubscribeComponent } from '../../classes/subscribe-component';
import { FormHelper } from '../../helpers/form.helpers';

@Component({
  selector: 'app-notify-settings',
  templateUrl: './notify-settings.component.html',
  styleUrls: ['./notify-settings.component.scss']
})
export class NotifySettingsComponent extends SubscribeComponent {
  @Input() disabled = false;
  @Input() isCommunity = false;

  @Input() set data(x: EstateNotify | undefined) {
    FormHelper.patch(this.notifyForm, this.patchNotifyForm(x));
  }

  @Output() dataChange = new EventEmitter<EstateNotify>();

  public notifyForm = this.buildNotifyForm();
  public get notifyKeys(): EstateNotifyKey[] { return this._notifyKeys(this.isCommunity); } // prettier-ignore

  ESTATE_NOTIFY_DAYS = ESTATE_NOTIFY_DAYS;

  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.subscription$.add(this.notifyForm.valueChanges.subscribe((value) => this.dataChange.emit(this.parseNotifyForm(value))));
  }

  private buildNotifyForm(): FormGroup {
    const daysEntries = Object.fromEntries(ESTATE_NOTIFY_DAYS.map((days) => [days, false]));

    return this.fb.group(
      Object.fromEntries(ESTATE_NOTIFY_KEYS.map((key) => [key, this.fb.group(daysEntries)]))
    ); // prettier-ignore
  }

  private _notifyKeys(isCommunity: boolean): EstateNotifyKey[] {
    let keys = [...ESTATE_NOTIFY_KEYS];
    if (isCommunity) {
      keys = ArrHlp.removeFirstMatch(keys, (key) => key == 'agreement');
    }
    return keys;
  }

  private patchNotifyForm(data?: EstateNotify): Record<EstateNotifyKey, Record<number, boolean>> {
    return Object.fromEntries(
      ESTATE_NOTIFY_KEYS.map((key) => {
        const dataValues = new Set(data ? data[key] : undefined);
        const formValues: [number, boolean][] = ESTATE_NOTIFY_DAYS.map((days) => [days, dataValues.has(days)]);
        return [key, Object.fromEntries(formValues)];
      })
    ) as any; // HACK: Object.fromEntries returns {[key:string]: T}
  }

  private parseNotifyForm(value: Record<EstateNotifyKey, Record<number, boolean>>): EstateNotify {
    return Object.fromEntries(
      ESTATE_NOTIFY_KEYS.map((key) => {
        const formValue = value[key];
        return [key, ESTATE_NOTIFY_DAYS.filter((days) => formValue[days])];
      })
    ) as any; // HACK: Object.fromEntries returns {[key:string]: T}
  }
}
